<template>
  <div>
    <div class="row">
      <div class="col text-right">
        <div class="GerenciadorResultadosAction--border">
          <button class="btn btn-secondary GerenciadorResultadosAction--btnGreen"
                  @click="$emit('onCumprirTodos')">
            <icon-svg icon="done"
                      class="icon icon--sm icons--white" />
            Cumprir todas as selecionadas
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "GerenciadorResultadosAction"
  }
</script>

<style scoped lang="scss">
  .GerenciadorResultadosAction {
    &--border {
      border: 1px solid black;
      padding: 20px;
    }

    &--btnGreen {
      background-color: #205e3b;
      border-color: #205e3b;
    }
  }
</style>
